import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';

// Tabs
import AircraftLogbookHumsTab from './AircraftLogbookHumsTab';
import AircraftLogbookTransitInspectionTab from './AircraftLogbookTransitInspectionTab';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookFlightAdditionalItensTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          aircraft_logbook_id: this.props.aircraft_logbook_id,
          approvals: [],
          hums_flight_report_legs: [],
          transit_inspections_flight_report_legs: [],
        };
        this.editHums = this.editHums.bind(this);
        this.editTransitInspection = this.editTransitInspection.bind(this);
      }

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }

      componentDidMount() {
        this.syncStateWithProps(this.props);
      }
    
      componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
          this.syncStateWithProps(this.props);
        }
      }
    
      syncStateWithProps(props) {
        this.setState({
          loaded: 1,
          aircraft_logbook_id: props.aircraft_logbook_id,
          hums_flight_report_legs: props.hums_flight_report_legs || [],
          transit_inspections_flight_report_legs: props.transit_inspections_flight_report_legs || [],
          approvals: (props.approvals && props.approvals[5]) || [],
        });
      }
    
      // Fetch editando o HUMS
      editHums(flight_report_leg_id, hums_status, hums_confirmed, hums_justification = null) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          id: this.state.aircraft_logbook_id,
          flight_report_leg_id: flight_report_leg_id,
          hums_status: hums_status,
          hums_confirmed: hums_confirmed,
          hums_justification: hums_justification,
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        var url = '/relatorio/voo/trecho/hums';
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
            self.setState({
              flight_report_leg_id: '',
            });
          }).catch((error) => {
            console.error(error);
          });
        });
      }

      // Fetch aprovação de trânsito
      editTransitInspection(flight_report_leg_id) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          id: this.state.aircraft_logbook_id,
          flight_report_leg_id: flight_report_leg_id,
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        var url = '/relatorio/voo/trecho/inspection';
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
            self.setState({
              flight_report_leg_id: '',
            });
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    
      render() {
        var self = this;
        return (
    <div>
      <RequestApi ref={'request_api'} />
      <h3 className="page-title pull-left">Additional Itens</h3>
      <div className="clearfix"></div>
      <hr/>
      <div className="table-responsive">
        <table className="table table-bordered table-hover table-striped">
          <caption>HUMS</caption>
          <thead>
            <tr className="text-center">
              <th>ST</th>
              <th>Status</th>
              <th>Confirmed?</th>
              <th>User</th>
              <th>Approval Date</th>
            </tr>
          </thead>
          <tbody id="hums">
            {self.state.hums_flight_report_legs.map(function(k) {
              return(
                <AircraftLogbookHumsTab editHums={self.editHums} hums={k} handleAlert={self.props.handleAlert} />
              );
            })
            }
          </tbody>
        </table>
      </div>
      <hr/>
      <div className="table-responsive">
        <table className="table table-bordered table-hover table-striped">
          <caption>Transit Inspection</caption>
          <thead>
            <tr className="text-center">
              <th>ST</th>
              <th>User</th>
              <th>Approval Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody id="transit_inspection">
            {self.state.transit_inspections_flight_report_legs.map(function(k) {
              return(
                <AircraftLogbookTransitInspectionTab editTransitInspection={self.editTransitInspection} transit_inspection={k} />
              );
            })
            }
          </tbody>
        </table>
      </div>
    </div>
    );
  }
}

export default AircraftLogbookFlightAdditionalItensTab;



// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookFlightAdditionalItensTab.js